import React from 'react'
// import Image from '../Image'
// import Markdown from 'markdown-to-jsx'
// import ModalVideoButton from '../Modals/ModalVideoButton'
import styles from './grid-gallery.module.sass'

export default function GridGallery({ children }) {
  return <div className={styles.gridGallery}>{children}</div>
}

// return <div className={styles.gridGallery}>{arrayChildren.map(child => (child.type.name === 'Image' ? <Image {...child.props} /> : child))}</div>
// return child.type.name === 'Image' ? { ...child, props: { ...child.props, wrapper: true } } : child
